import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BilibiliOutlinedSvg from "@ant-design/icons-svg/es/asn/BilibiliOutlined";
import AntdIcon from "../components/AntdIcon";
var BilibiliOutlined = function BilibiliOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BilibiliOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BilibiliOutlined.displayName = 'BilibiliOutlined';
}
export default /*#__PURE__*/React.forwardRef(BilibiliOutlined);